import { TChatCustomActionModalShowPayload, EChatCustomActionModalActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Открыть окно действия, которое пришло по вебсокету, с чатом
 */
export const openChatCustomActionModal = actionGenerator<
  EChatCustomActionModalActionTypes.Show,
  TChatCustomActionModalShowPayload
>(EChatCustomActionModalActionTypes.Show);

/**
 * Закрыть окно действия, которое пришло по вебсокету, с чатом
 */
export const closeChatCustomActionModal = actionGenerator<EChatCustomActionModalActionTypes.Hide, void>(
  EChatCustomActionModalActionTypes.Hide,
);
